import { DownOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { type BasicSigningModuleSpecsFragment } from '../../../../api/fragments/BasicSigningModuleSpecs';
import { type PermissionValues } from '../../../../utilities/hasPermissions';
import useDeleteModule from '../useDeleteModule';
import { useUpdateDrawer } from './UpdateDrawer';

export type BasicSigningModuleActionsProps = {
    module: BasicSigningModuleSpecsFragment;
    permissions: Pick<PermissionValues, 'hasDeletePermission' | 'hasUpdatePermission'>;
};

const BasicSigningModuleActions = ({ module, permissions }: BasicSigningModuleActionsProps) => {
    const { t } = useTranslation(['basicSigningModuleDetails', 'moduleDetails']);
    const updateDrawer = useUpdateDrawer(module);
    const deleteModule = useDeleteModule(module.id);
    const { hasUpdatePermission, hasDeletePermission } = permissions;

    const items = [
        hasUpdatePermission && {
            label: t('basicSigningModuleDetails:mainActionButtons.updateSpecs'),
            key: 'updateSpecs',
            icon: <EditOutlined />,
            onClick: updateDrawer.open,
        },
        hasDeletePermission && {
            label: t('basicSigningModuleDetails:mainActionButtons.delete'),
            key: 'delete',
            icon: <DeleteOutlined />,
            onClick: deleteModule,
            danger: true,
        },
    ].filter(Boolean);

    if (!items.length) {
        return null;
    }

    return (
        <>
            <Dropdown overlay={<Menu items={items} />}>
                <Button type="primary">
                    <Space>
                        <span>{t('basicSigningModuleDetails:mainActionButtons.actions')}</span>
                        <DownOutlined />
                    </Space>
                </Button>
            </Dropdown>
            {updateDrawer.render()}
        </>
    );
};

export default BasicSigningModuleActions;
